// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlatformOutlinedSvg from "@fishx/icons-svg/es/asn/PlatformOutlined";
import FishxIcon from '../components/FishxIcon';

var PlatformOutlined = function PlatformOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlatformOutlinedSvg
  }));
};

PlatformOutlined.displayName = 'PlatformOutlined';
export default React.forwardRef(PlatformOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlatformOutlined.js
// module id = 3795
// module chunks = 0